// src/arrowDownToBracket.tsx
var arrowDownToBracket = {
  iconName: "arrow-down-to-bracket",
  width: 448,
  height: 512,
  svgPathData: "M241 345l-17 17-17-17-136-136-17-17 33.9-33.9 17 17 95 95 0-270.1 48 0 0 270.1 95-95 17-17 33.9 33.9-17 17-136 136zM48 344l0 120 352 0 0-144 48 0 0 192-448 0 0-192 48 0 0 24z",
  iconType: "fill",
  fill: "none"
};

// src/arrowDownToLine.tsx
var arrowDownToLine = {
  iconName: "arrow-down-to-line",
  width: 384,
  height: 512,
  svgPathData: "M360 512l24 0 0-48-384 0 0 48 360 0zM175 377l17 17 17-17 136-136 17-17-33.9-33.9-17 17-95 95 0-302.1-48 0 0 302.1-95-95-17-17-33.9 33.9 17 17 136 136z",
  iconType: "fill",
  fill: "none"
};

// src/bell.tsx
var bell = {
  iconName: "bell",
  width: 512,
  height: 512,
  svgPathData: "M280 0l-48 0 0 33.7C150.6 45.3 88 115.4 88 200l0 72-72 144 480 0-72-144 0-72c0-84.6-62.6-154.7-144-166.3L280 0zM418.3 368l-324.7 0 37.3-74.5c3.3-6.7 5.1-14 5.1-21.5l0-72c0-66.3 53.7-120 120-120s120 53.7 120 120l0 72c0 7.5 1.7 14.8 5.1 21.5L418.3 368zM188.1 464c9.9 28 36.6 48 67.9 48s58-20 67.9-48l-135.8 0z",
  iconType: "fill",
  fill: "none"
};

// src/bin.tsx
var bin = {
  iconName: "bin",
  width: 576,
  height: 512,
  svgPathData: "M32 64l-32 0 0 48 33.5 0 30.5 336 448 0 30.5-336 33.5 0 0-48-544 0zm462.3 48l-26.2 288-360.3 0-26.2-288 412.7 0z",
  iconType: "fill",
  fill: "none"
};

// src/boxOpen.tsx
var boxOpen = {
  iconName: "box-open",
  width: 640,
  height: 512,
  svgPathData: "M294 370.1l-11 23.8-22.7-13-132.1-75.5 0 64.5 168 93.3 0-97.9-2.2 4.8zm-4.9-103.9l-178.6-99.2-30.1 55.8 181 103.4 27.7-60zM146.4 132L320.2 228.5 494 132 320.2 35.5 146.4 132zm413.8 82.7l0 183.5-12.3 6.9-216 120-11.7 6.5-11.7-6.5-216-120-12.3-6.9 0-120.2C47 259 25.6 246.7 16 241.2l11.1-20.6 56-104 3.3-6.2 6.1-3.4 216-120 11.7-6.5 11.7 6.5 216 120 5.6 3.1 3.3 5.5c37.9 63.2 58.1 96.8 60.3 100.6L576 240.9c-9.7-16.2-15-25-15.8-26.3zm-216 55.5l0 193.1 168-93.3 0-193.1-168 93.3z",
  iconType: "fill",
  fill: "none"
};

// src/briefcase.tsx
var briefcase = {
  iconName: "briefcase",
  width: 512,
  height: 512,
  svgPathData: "M168 0l-24 0 0 96-144 0 0 384 512 0 0-384-144 0 0-96-200 0zM464 256l-416 0 0-112 416 0 0 112zM320 304l144 0 0 128-416 0 0-128 144 0 0 48 128 0 0-48zm0-208l-128 0 0-48 128 0 0 48z",
  iconType: "fill",
  fill: "none"
};

// src/broomWide.tsx
var broomWide = {
  iconName: "broom-wide",
  width: 576,
  height: 512,
  svgPathData: "M336 176L544-32 576 0 368 208 416 256 265.7 501.9 240 544c-.7-.7-69.1-69.1-205.1-205.1L0 304 42.1 278.3 288 128 336 176zm-91.3 34.7l88.6 88.6 22.1-36.1-74.6-74.6-36.1 22.1zm-42.1 25.7l-125.5 76.7 25.9 25.9 57.1-19-19 57.1 89.9 89.9 76.7-125.5-105-105z",
  iconType: "fill",
  fill: "none"
};

// src/calendar.tsx
var calendar = {
  iconName: "calendar",
  width: 448,
  height: 512,
  svgPathData: "M144 0l0 64 160 0 0-64 48 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 48 0zm0 112l-96 0 0 64 352 0 0-64-256 0zM48 224l0 208 352 0 0-208-352 0z",
  iconType: "fill",
  fill: "none"
};

// src/calendarClock.tsx
var calendarClock = {
  iconName: "calendar-clock",
  width: 576,
  height: 512,
  svgPathData: "M176 0l0 64 160 0 0-64 48 0 0 64 96 0 0 150c-15.3-3.9-31.4-6-48-6-27.3 0-53.3 5.7-76.9 16l-275.1 0 0 208 162.7 0c2.8 16.8 7.8 32.9 14.8 48l-225.4 0 0-416 96 0 0-64 48 0zm0 112l-96 0 0 64 352 0 0-64-256 0zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 96 80 0 0-32-48 0 0-64z",
  iconType: "fill",
  fill: "none"
};

// src/calendarDay.tsx
var calendarDay = {
  iconName: "calendar-day",
  width: 448,
  height: 512,
  svgPathData: "M144 0l0 64 160 0 0-64 48 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 48 0zm0 112l-96 0 0 320 352 0 0-320-256 0zm0 144l0 80 80 0 0-80-80 0zM96 208l176 0 0 176-176 0 0-176z",
  iconType: "fill",
  fill: "none"
};

// src/chartMixedUpCircleDollar.tsx
var chartMixedUpCircleDollar = {
  iconName: "chart-mixed-up-circle-dollar",
  width: 640,
  height: 512,
  svgPathData: "M416.3 0l160 0 0 160-48 0 0-79.2-160.4 137.5-15.8 13.5-15.6-13.7-114.2-99.9-152.7 101.8-20 13.3-26.6-39.9 20-13.3 168-112 15.3-10.2 13.8 12.1 112.4 98.3 140.3-120.3-76.5 0 0-48zm-168 224l0 256-48 0 0-256 48 0zm-136 96l0 160-48 0 0-160 48 0zm208 80a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-72l0-24-32 0 0 24.1c-22.3 1.1-40 19.5-40 42.1 0 20.4 14.6 37.8 34.6 41.5l45 8.2c4.8 .9 8.3 5.1 8.3 10 0 5.6-4.6 10.2-10.2 10.2l-69.8 0 0 32 32 0 0 24 32 0 0-24 5.8 0c23.3 0 42.2-18.9 42.2-42.2 0-20.4-14.6-37.8-34.6-41.5l-45-8.2c-4.8-.9-8.3-5.1-8.3-10 0-5.6 4.6-10.2 10.2-10.2l61.8 0 0-32-32 0z",
  iconType: "fill",
  fill: "none"
};

// src/chartUser.tsx
var chartUser = {
  iconName: "chart-user",
  width: 640,
  height: 512,
  svgPathData: "M128 32l480 0 0 416-295.6 0-21-48 268.6 0 0-320-384 0 0 68c-10.2-2.6-21-4-32-4-5.4 0-10.8 .3-16 1l0-113zM352 254.1l78.1-78.1-54.1 0 0-48 136 0 0 136-48 0 0-54.1-95 95-17 17c-8.8-8.8-25.1-25.1-49-49l-17-17 33.9-33.9c11.6 11.6 22.3 22.3 32 32zM64 272a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM232 384l56 128-288 0 56-128 176 0z",
  iconType: "fill",
  fill: "none"
};

// src/chevronDown.tsx
var chevronDown = {
  iconName: "chevron-down",
  width: 512,
  height: 512,
  svgPathData: "M256.4 425.9l17-17 200-200 17-17-33.9-33.9-17 17-183 183-183-183-17-17-33.9 33.9 17 17 200 200 17 17z",
  iconType: "fill"
};

// src/chevronLeft.tsx
var chevronLeft = {
  iconName: "chevron-left",
  width: 384,
  height: 512,
  svgPathData: "M22.5 256l17-17 200-200 17-17 33.9 33.9-17 17-183 183 183 183 17 17-33.9 33.9-17-17-200-200-17-17z",
  iconType: "fill"
};

// src/chevronRight.tsx
var chevronRight = {
  iconName: "chevron-right",
  width: 384,
  height: 512,
  svgPathData: "M362.4 256l-17 17-200 200-17 17-33.9-33.9 17-17 183-183-183-183-17-17 33.9-33.9 17 17 200 200 17 17z",
  iconType: "fill"
};

// src/chevronUp.tsx
var chevronUp = {
  iconName: "chevron-up",
  width: 512,
  height: 512,
  svgPathData: "M256.4 86.1l17 17 200 200 17 17-33.9 33.9-17-17-183-183-183 183-17 17-33.9-33.9 17-17 200-200 17-17z",
  iconType: "fill",
  fill: "none"
};

// src/chevronUpDown.tsx
var chevronUpDown = {
  iconName: "chevron-up-down",
  width: 16,
  height: 16,
  svgPathData: "m5 11 2.989 2.5L11 11M11 5 8.011 2.5 5 5",
  iconType: "stroke",
  fill: "none"
};

// src/circleDollar.tsx
var circleDollar = {
  iconName: "circle-dollar",
  width: 512,
  height: 512,
  svgPathData: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392l-48 0 0 32.3c-31.5 3.3-56 29.9-56 62.2 0 31.1 22.9 57.5 53.7 61.9l45.8 6.5c7.2 1 12.5 7.2 12.5 14.4 0 8-6.5 14.6-14.6 14.6l-89.4 0 0 48 48 0 0 32 48 0 0-32.3c31.5-3.3 56-29.9 56-62.2 0-31.1-22.9-57.5-53.7-61.9L236.5 229c-7.2-1-12.5-7.2-12.5-14.4 0-8 6.5-14.6 14.6-14.6l81.4 0 0-48-40 0 0-32z",
  iconType: "fill",
  fill: "none"
};

// src/circleInfo.tsx
var circleInfo = {
  iconName: "circle-info",
  width: 512,
  height: 512,
  svgPathData: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM216 336l-24 0 0 48 128 0 0-48-32 0 0-112-96 0 0 48 48 0 0 64-24 0zm72-144l0-64-64 0 0 64 64 0z",
  iconType: "fill",
  strokeWidth: 0
};

// src/circleQuestion.tsx
var circleQuestion = {
  iconName: "circle-question",
  width: 512,
  height: 512,
  svgPathData: "M464 256a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256-80c-17.7 0-32 14.3-32 32l-48 0c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.1-20.5 57.5-38.2 70-6.3 4.4-12.5 7.8-17.8 10.4l0 21.9-48 0 0-56.7c1.4-.4 2.7-.7 4.1-1.1 12.2-3.2 23.3-6.1 34.1-13.7 10.4-7.3 17.8-16.9 17.8-30.8 0-17.7-14.3-32-32-32zM232 344l48 0 0 48-48 0 0-48z",
  iconType: "fill",
  fill: "none"
};

// src/circleSterling.tsx
var circleSterling = {
  iconName: "circle-sterling",
  width: 512,
  height: 512,
  svgPathData: "M464 256a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm160 0l0-32 18.9 0c-15.8-55.2 25.5-112 84.7-112l2.2 0c19.7 0 38.8 6.4 54.5 18.2 8.6 6.5 19.7 14.8 33.4 25l-28.8 38.4c-13.6-10.2-24.8-18.6-33.4-25-7.4-5.6-16.4-8.6-25.7-8.6l-2.2 0c-28.5 0-47.8 28.9-37 55.2l1.4 3.5c.7 1.8 1.4 3.5 2 5.3l90 0 0 32-84 0c.7 22.6-5.8 45-19.1 64l135.1 0 0 48-200 0 0-42.5c1.1-1.4 9-11.6 23.7-30.5 8.8-11.3 12.9-25.1 12.2-39L160 256z",
  iconType: "fill",
  fill: "none"
};

// src/circleTick.tsx
var circleTick = {
  iconName: "circle-tick",
  width: 512,
  height: 512,
  svgPathData: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209l17-17L352 158.1l-17 17-111 111-47-47-17-17L126.1 256l17 17 64 64 17 17 17-17L369 209z",
  iconType: "fill",
  fill: "none"
};

// src/clock.tsx
var clock = {
  iconName: "clock",
  width: 512,
  height: 512,
  svgPathData: "M464 256a208 208 0 1 1 -416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zM232 120l0 148.8 10.7 7.1 96 64 20 13.3 26.6-39.9c-2.4-1.6-37.5-25-105.3-70.2l0-147.2-48 0 0 24z",
  iconType: "fill",
  fill: "none"
};

// src/creditCard.tsx
var creditCard = {
  iconName: "credit-card",
  width: 512,
  height: 512,
  svgPathData: "M464 112l0 48-416 0 0-48 416 0zm0 112l0 176-416 0 0-176 416 0zM48 64l-48 0 0 384 512 0 0-384-464 0zM80 320l0 48 96 0 0-48-96 0zm144 0l0 48 112 0 0-48-112 0z",
  iconType: "fill",
  fill: "none"
};

// src/creditCardSync.tsx
var creditCardSync = {
  iconName: "credit-card-sync",
  width: 640,
  height: 512,
  svgPathData: "M0 32l48 0 480 0 48 0 0 48 0 131.2c-24-12.3-51.2-19.2-80-19.2c-22.6 0-44.2 4.3-64 12l0-12-112 0 0 32L48 224l0 208 284 0c6.9 17.5 16.4 33.7 28.2 48L48 480 0 480l0-48L0 80 0 32zM48 80l0 48 480 0 0-48L48 80zM96 336l96 0 0 48-96 0 0-48zm128 0l96 0 0 32.8c0 5.1 .3 10.2 .7 15.2L224 384l0-48zM352 224l48 0 0 24 0 12.7c25.5-22.8 59.1-36.7 96-36.7c59.1 0 109.8 35.6 132 86.4l-44 19.2c-14.8-33.9-48.7-57.6-88-57.6c-28.5 0-54 12.3-71.6 32l31.6 0 24 0 0 48-24 0-80 0-24 0 0-24 0-80 0-24zm12 201.6l44-19.2c14.8 33.9 48.7 57.6 88 57.6c28.5 0 54-12.3 71.6-32L536 432l-24 0 0-48 24 0 80 0 24 0 0 24 0 80 0 24-48 0 0-24 0-12.7c-25.5 22.8-59.1 36.7-96 36.7c-59.1 0-109.8-35.6-132-86.4z",
  iconType: "fill",
  fill: "none"
};

// src/cross.tsx
var cross = {
  iconName: "cross",
  width: 640,
  height: 640,
  svgPathData: "M182.9 137.4L160.3 114.7L115 160L137.6 182.6L275 320L137.6 457.4L115 480L160.3 525.3L182.9 502.6L320.3 365.3L457.6 502.6L480.3 525.3L525.5 480L502.9 457.4L365.5 320L502.9 182.6L525.5 160L480.3 114.7L457.6 137.4L320.3 274.7L182.9 137.4z",
  iconType: "fill"
};

// src/dollarSign.tsx
var dollarSign = {
  iconName: "dollar-sign",
  width: 320,
  height: 512,
  svgPathData: "M136 0l48 0 0 64 88 0 0 48-154 0c-29.8 0-54 24.2-54 54 0 26.4 19.1 48.9 45.1 53.2l106.1 17.7c51.3 8.5 88.8 52.9 88.8 104.8 0 58.7-47.6 106.3-106.3 106.3l-13.7 0 0 64-48 0 0-64-104 0 0-48 165.7 0c32.2 0 58.3-26.1 58.3-58.3 0-28.5-20.6-52.8-48.7-57.5L101.2 266.5C52 258.3 16 215.8 16 166 16 109.6 61.6 64 118 64l18 0 0-64z",
  iconType: "fill",
  fill: "none"
};

// src/dropdown.tsx
var dropdown = {
  iconName: "dropdown",
  width: 512,
  height: 512,
  svgPathData: "M256 417.9l17-17L465 209l17-17L448 158.1l-17 17-175 175L81 175l-17-17L30.1 192l17 17L239 401l17 17z",
  iconType: "fill",
  fill: "none"
};

// src/error.tsx
var error = {
  iconName: "error",
  width: 512,
  height: 512,
  svgPathData: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-384H232v24V264v24h48V264 152 128zM232 368h48V320H232v48z",
  iconType: "fill",
  strokeWidth: 0
};

// src/errorCircle.tsx
var errorCircle = {
  iconName: "error-circle",
  width: 20,
  height: 21,
  svgPathData: "M15.0391 16.9062L3.59375 5.46094C2.5 6.86719 1.875 8.625 1.875 10.5C1.875 14.9922 5.50781 18.625 10 18.625C11.875 18.625 13.6328 18 15.0391 16.9062ZM16.3672 15.5781C17.4609 14.1719 18.125 12.4141 18.125 10.5C18.125 6.04688 14.4531 2.375 10 2.375C8.08594 2.375 6.32812 3.03906 4.92188 4.13281L16.3672 15.5781ZM0 10.5C0 6.94531 1.875 3.66406 5 1.86719C8.08594 0.0703125 11.875 0.0703125 15 1.86719C18.0859 3.66406 20 6.94531 20 10.5C20 14.0938 18.0859 17.375 15 19.1719C11.875 20.9688 8.08594 20.9688 5 19.1719C1.875 17.375 0 14.0938 0 10.5Z",
  iconType: "fill",
  fill: "none"
};

// src/fett.tsx
var fett = {
  iconName: "fett",
  width: 448,
  height: 512,
  svgPathData: "M323 120C309.4 78 270 48 224 48s-85.4 30-99 72H323zm5.5 36.4L248 171.5v95.9l9.9-1.7c8.4-48.3 43-79.4 71.5-95.4l-.9-13.8zm-209 0l-.9 13.8c28.5 16 63.1 47.1 71.5 95.4l9.9 1.7V171.5l-80.5-15.1zM96 70C123.1 27.7 170.5 0 224 0c80.1 0 146.5 62.2 151.7 142.2l8.3 128.2 1.4 21.4-21.2 3.7-136 24c-2.8 .5-5.6 .5-8.3 0l-136-24-21.2-3.7L64 271.2V256 16 0H80 96h16V32H96V70zM64.5 464H160l64-48 64 48h95.5l-19.2-64H83.7L64.5 464zM48 352H400l33.6 112L448 512H397.9 50.1 0l14.4-48L48 352z",
  iconType: "fill",
  fill: "none"
};

// src/fileArrowDown.tsx
var fileArrowDown = {
  iconName: "file-arrow-down",
  width: 384,
  height: 512,
  svgPathData: "M176 48l-128 0 0 416 288 0 0-256-160 0 0-160zM316.1 160l-92.1-92.1 0 92.1 92.1 0zM48 0L224 0 384 160 384 512 0 512 0 0 48 0zM192 441.9c-3.5-3.5-30.5-30.5-81-81l-17-17 33.9-33.9c10.3 10.3 23.6 23.6 40 40l0-94.1 48 0 0 94.1c16.4-16.4 29.7-29.7 40-40L289.9 344c-3.5 3.5-30.5 30.5-81 81l-17 17z",
  iconType: "fill",
  fill: "none"
};

// src/fileCertificate.tsx
var fileCertificate = {
  iconName: "file-certificate",
  width: 576,
  height: 512,
  svgPathData: "M304 48l-128 0 0 102.6c-15.3-4.3-31.4-6.6-48-6.6l0-144 224 0 160 160 0 352-256 0 0-48 208 0 0-256-160 0 0-160zM444.1 160l-92.1-92.1 0 92.1 92.1 0zM208 419.9l0 132.1-80-40-80 40 0-132.1C18.7 396.5 0 360.4 0 320 0 249.3 57.3 192 128 192s128 57.3 128 128c0 40.4-18.7 76.5-48 99.9zM176 320a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z",
  iconType: "fill",
  fill: "none"
};

// src/fileCircleInfo.tsx
var fileCircleInfo = {
  iconName: "file-circle-info",
  width: 576,
  height: 512,
  svgPathData: "M208 48l-128 0 0 416 170.9 0c6.1 17.3 14.6 33.4 25.1 48l-244 0 0-512 224 0 160 160 0 48.7c-16.7 1.4-32.8 4.9-48 10.3l0-10.9-160 0 0-160zM348.1 160l-92.1-92.1 0 92.1 92.1 0zM432 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm15.3 64l-32 0 0 32 32 0 0-32zm1.2 64c-23.9 0-40.8 0-48.5 0l0 32 16 0 .5 0 0 32-.5 0-16 0 0 32c8 0 24 0 48 0l.5 0 15.5 0 0-32-15.5 0 0-64z",
  iconType: "fill",
  fill: "none"
};

// src/fileCirclePlus.tsx
var fileCirclePlus = {
  iconName: "file-circle-plus",
  width: 576,
  height: 512,
  svgPathData: "M80 48l128 0 0 160 208 0 0-48-160-160-224 0 0 512 244 0c-10.5-14.6-19-30.7-25.1-48L80 464 80 48zM256 67.9l92.1 92.1-92.1 0 0-92.1zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 64 0 0 32-64 0 0 64-32 0 0-64-64 0 0-32 64 0 0-64 32 0 0 16z",
  iconType: "fill",
  fill: "none"
};

// src/filePen.tsx
var filePen = {
  iconName: "file-pen",
  width: 640,
  height: 512,
  svgPathData: "M240 48l-128 0 0 416 172.2 0-8 48-212.2 0 0-512 224 0 160 160 0 107.7-48 48 0-107.7-160 0 0-160zM380.1 160l-92.1-92.1 0 92.1 92.1 0zM544 239.9l80 80-52.8 52.8-80-80 52.8-52.8zm-208 208l132.6-132.6 80 80-132.6 132.6-96 16 16-96z",
  iconType: "fill",
  fill: "none"
};

// src/fileShield.tsx
var fileShield = {
  iconName: "file-shield",
  width: 576,
  height: 512,
  svgPathData: "M208 48l-128 0 0 416 186.1 0c8.8 17.2 19.6 33.4 32.2 48l-266.3 0 0-512 224 0 160 160 0 50.7-48 16 0-18.7-160 0 0-160zM348.1 160l-92.1-92.1 0 92.1 92.1 0zM462 530.8l-30 13.3-30-13.3C332.7 500 288 431.2 288 355.3l0-51.2 144-48 144 48 0 51.2c0 75.9-44.7 144.6-114 175.5zm-30-39.2l10.5-4.7c52-23.1 85.5-74.7 85.5-131.6l0-16.6-96-32 0 184.9z",
  iconType: "fill",
  fill: "none"
};

// src/fileSignature.tsx
var fileSignature = {
  iconName: "file-signature",
  width: 640,
  height: 512,
  svgPathData: "M112 48l128 0 0 160 160 0 0 107.7 48-48 0-107.7-160-160-224 0 0 512 212.2 0 8-48-172.2 0 0-416zM302.8 368l-33.4-66.7-6.6-13.3-42.2 0-7.2 8.8-72 88 37.2 30.4 58.5-71.5c23.5 46.9 35.5 71 36.1 72.3l26.5 0 48-48-44.8 0zM288 67.9l92.1 92.1-92.1 0 0-92.1zm256 172l-52.8 52.8 80 80 52.8-52.8-80-80zm-208 208l-16 96 96-16 132.6-132.6-80-80-132.6 132.6z",
  iconType: "fill",
  fill: "none"
};

// src/grid2.tsx
var grid2 = {
  iconName: "grid2",
  width: 512,
  height: 512,
  svgPathData: "M224 32L32 32l0 192 192 0 0-192zm0 256L32 288l0 192 192 0 0-192zM288 32l0 192 192 0 0-192L288 32zM480 288l-192 0 0 192 192 0 0-192z",
  iconType: "fill",
  fill: "none"
};

// src/handHoldingHeart.tsx
var handHoldingHeart = {
  iconName: "hand-holding-heart",
  width: 576,
  height: 512,
  svgPathData: "M279.9 23l8.4 11.7 8.4-11.7c14.1-19.5 36.6-31 60.7-31 41.4 0 74.9 33.5 74.9 74.9l0 2.4c0 85.3-144 178.7-144 178.7s-144-93.3-144-178.7l0-2.4c0-41.4 33.5-74.9 74.9-74.9 24 0 46.6 11.5 60.7 31zM161.1 288l223.3 0 0 80 9 0c75.6-48 114.2-72.5 115.7-73.5 2.6 4.3 22.8 38 60.7 101.1l12 20-19.6 12.6-124.8 80-5.9 3.8-431 0 0-48 417 0 99.3-63.6-23.4-38.9-80 50.8-5.9 3.7-175 0 0-48 104 0 0-32-160.7 0-90 60-6 4-79.3 0 0-48 64.7 0 90-60 6-4z",
  iconType: "fill",
  fill: "none"
};

// src/handshake.tsx
var handshake = {
  iconName: "handshake",
  width: 640,
  height: 512,
  svgPathData: "M598.6 75.4L618 61.3 589.7 22.5C586 25.2 554.7 48 495.8 90.8l-34.1-22.7-6-4-145.2 0 0 0-144 0c-2.9 2.9-11.1 11.1-24.5 24.5-56.3-40.9-86.6-62.9-90.8-66.1L22.9 61.3c1.5 1.1 37.3 27.1 107.4 78.1l16.6 12.1c7.9-7.9 21.1-21.1 39.5-39.5l76.1 0-103 103-17 17c12.1 12.1 21.8 21.8 29.1 29.1 46.9 46.9 122.8 46.9 169.7 0L368.4 233.9 494.5 360c-16.7 16.7-29.4 29.4-38.1 38.1l-47-47-33.9 33.9 47 47-16 16-44.1 0-65-65-33.9 33.9 31 31-60.1 0-169-169-17-17-33.9 33.9 17 17 176 176 7 7 128 0 1 1 1-1 81.9 0 7-7c225.8-225.8 167.2-167.2 193-193l-33.9-33.9-64 64-143-143-17-17c-6.8 6.8-27.2 27.2-61.1 61.1-26.5 26.5-68.5 28-96.7 4.6l119.8-119.8 62.1 0 0 0 48.7 0c32.6 21.8 51.3 34.2 55.9 37.2l13.5-9.8 88-64z",
  iconType: "fill",
  fill: "none"
};

// src/home.tsx
var home = {
  iconName: "home",
  width: 576,
  height: 512,
  svgPathData: "M288.4-8.8l16 14.4 232 208 17.9 16-32 35.7c-13.6-12.2-22.2-19.9-25.8-23.2l0 269.3-416 0 0-269.3c-3.7 3.3-12.3 11-25.8 23.2l-32-35.7 17.9-16 232-208 16-14.4zm0 64.5l-160 143.5 0 264.3 64 0 0-176 192 0 0 176 64 0 0-264.3-160-143.4zm-48 407.8l96 0 0-128-96 0 0 128z",
  iconType: "fill",
  fill: "none"
};

// src/houseHeart.tsx
var houseHeart = {
  iconName: "house-heart",
  width: 576,
  height: 512,
  svgPathData: "M288.4-8.2l16 14.4 232 208 17.9 16-32 35.7c-13.6-12.2-22.2-19.9-25.8-23.2l0 269.3-416 0 0-269.3c-3.7 3.3-12.3 11-25.8 23.2l-32-35.7 17.9-16 232-208 16-14.4zm0 64.5l-160 143.5 0 264.3 320 0 0-264.3-160-143.4zm-9.1 198.7l9.1 9.1 9.1-9.1c9.5-9.5 22.5-14.9 36-14.9l2.9 0c26.5 0 48 21.5 48 48 0 64-96 112-96 112s-96-48-96-112c0-26.5 21.5-48 48-48l2.9 0c13.5 0 26.5 5.4 36 14.9z",
  iconType: "fill",
  fill: "none"
};

// src/leftArrow.tsx
var leftArrow = {
  iconName: "left-arrow",
  width: 448,
  height: 512,
  svgPathData: "M18.2 273l-17-17 17-17L171.8 85.4l17-17 33.9 33.9-17 17L93.1 232 424 232l24 0 0 48-24 0L93.1 280 205.8 392.6l17 17-33.9 33.9-17-17L18.2 273z",
  iconType: "fill"
};

// src/lightbulbOn.tsx
var lightbulbOn = {
  iconName: "lightbulb-on",
  width: 640,
  height: 512,
  svgPathData: "M392 316.8c43.2-25 72-71.5 72-124.8 0-79.5-64.5-144-144-144S176 112.5 176 192c0 53.2 28.9 99.8 72 124.8l24 13.9 0 53.4 96 0 0-53.4 24-13.9zM512 192c0 71.1-38.6 133.1-96 166.3l0 153.7-192 0 0-153.7C166.6 325.1 128 263.1 128 192 128 86 214 0 320 0S512 86 512 192zM320 144c-26.5 0-48 21.5-48 48l-48 0c0-53 43-96 96-96l0 48zM58.7 26.5l53.5 26.7-21.5 42.9C60.3 81 19.5 60.6 15.8 58.7L37.3 15.8 58.7 26.5zm544 42.9C579.6 81 561.8 89.9 549.3 96.2L527.8 53.3C558.2 38 599 17.7 602.7 15.8l21.5 42.9-21.5 10.7zM24 168l56 0 0 48-80 0 0-48 24 0zm560 0l56 0 0 48-80 0 0-48 24 0zM90.7 341.5C67.6 353 49.8 361.9 37.3 368.2L15.8 325.3C46.2 310 87 289.7 90.7 287.8l21.5 42.9-21.5 10.7zm458.5-53.7l74.9 37.5-21.5 42.9-74.9-37.5 21.5-42.9z",
  iconType: "fill",
  fill: "none"
};

// src/link.tsx
var link = {
  iconName: "link",
  width: 576,
  height: 512,
  svgPathData: "M427.5 88c-21.4 0-42.2 6.9-59.3 19.4-11.4-11.7-24.4-22.1-38.4-30.7 27-23.6 61.7-36.7 97.7-36.7 82 0 148.5 66.5 148.5 148.5 0 39.4-15.6 77.1-43.5 105l-79.1 79.1c-27.8 27.8-65.6 43.5-105 43.5-82 0-148.5-66.5-148.5-148.5 0-27.6 7.7-54.5 21.9-77.6L262.8 215c-9.6 15.7-14.8 33.8-14.8 52.5 0 55.5 45 100.5 100.5 100.5 26.6 0 52.2-10.6 71-29.4l79.1-79.1C517.4 240.6 528 215.1 528 188.5 528 133 483 88 427.5 88zm-200 56c-26.6 0-52.2 10.6-71 29.4L77.4 252.5c-18.8 18.8-29.4 44.4-29.4 71 0 55.5 45 100.5 100.5 100.5 21.4 0 42.2-6.9 59.3-19.4 11.4 11.8 24.4 22.1 38.4 30.7-27 23.6-61.7 36.7-97.7 36.7-82 0-148.5-66.5-148.5-148.5 0-39.4 15.6-77.1 43.5-105l79.1-79.1c27.8-27.8 65.6-43.5 105-43.5 82 0 148.5 66.5 148.5 148.5 0 27.6-7.7 54.5-21.9 77.6L313.2 297c9.6-15.7 14.8-33.8 14.8-52.5 0-55.5-45-100.5-100.5-100.5z",
  iconType: "fill",
  fill: "none"
};

// src/list.tsx
var list = {
  iconName: "list",
  width: 512,
  height: 512,
  svgPathData: "M112 48l-96 0 0 96 96 0 0-96zm72 24l-24 0 0 48 352 0 0-48-328 0zm0 160l-24 0 0 48 352 0 0-48-328 0zm0 160l-24 0 0 48 352 0 0-48-328 0zM16 208l0 96 96 0 0-96-96 0zm96 160l-96 0 0 96 96 0 0-96z",
  iconType: "fill",
  fill: "none"
};

// src/loading.tsx
var loading = {
  iconName: "loading",
  width: 512,
  height: 512,
  svgPathData: "M477.7 384c21.8-37.7 34.3-81.4 34.3-128C512 114.6 397.4 0 256 0V48c114.9 0 208 93.1 208 208c0 37.9-10.1 73.4-27.8 104l41.6 24z",
  iconType: "fill"
};

// src/lock.tsx
var lock = {
  iconName: "lock",
  width: 384,
  height: 512,
  svgPathData: "M112 96l0 64 160 0 0-64c0-44.2-35.8-80-80-80s-80 35.8-80 80zM64 208l-16 0 0 256 288 0 0-256-16 0 0 0-48 0 0 0-160 0 0 0-48 0 0 0zm0-48l0-64C64 25.3 121.3-32 192-32S320 25.3 320 96l0 64 64 0 0 352-384 0 0-352 64 0z",
  iconType: "fill",
  fill: "none"
};

// src/lockKeyhole.tsx
var lockKeyhole = {
  iconName: "lock-keyhole",
  width: 384,
  height: 512,
  svgPathData: "M192 16c44.2 0 80 35.8 80 80l0 64-160 0 0-64c0-44.2 35.8-80 80-80zM64 208l48 0 0 0 160 0 0 0 48 0 0 0 16 0 0 256-288 0 0-256 16 0 0 0zM64 96l0 64-64 0 0 352 384 0 0-352-64 0 0-64c0-70.7-57.3-128-128-128S64 25.3 64 96zM216 296l0-24-48 0 0 128 48 0 0-104z",
  iconType: "fill",
  fill: "none"
};

// src/magnifierPlus.tsx
var magnifierPlus = {
  iconName: "magnifier-plus",
  width: 20,
  height: 21,
  svgPathData: "M8.125 2.375C5.85938 2.375 3.82812 3.58594 2.69531 5.5C1.5625 7.45312 1.5625 9.83594 2.69531 11.75C3.82812 13.7031 5.85938 14.875 8.125 14.875C10.3516 14.875 12.3828 13.7031 13.5156 11.75C14.6484 9.83594 14.6484 7.45312 13.5156 5.5C12.3828 3.58594 10.3516 2.375 8.125 2.375ZM8.125 16.75C3.63281 16.75 0 13.1172 0 8.625C0 4.17188 3.63281 0.5 8.125 0.5C12.5781 0.5 16.25 4.17188 16.25 8.625C16.25 10.5391 15.5859 12.2969 14.4922 13.7031L19.3359 18.5469L20 19.2109L18.6719 20.5391L18.0078 19.875L13.1641 15.0312C11.7578 16.125 10 16.75 8.125 16.75ZM7.1875 13V12.0625V9.5625H4.6875H3.75V7.6875H4.6875H7.1875V5.1875V4.25H9.0625V5.1875V7.6875H11.5625H12.5V9.5625H11.5625H9.0625V12.0625V13H7.1875Z",
  iconType: "fill",
  fill: "none"
};

// src/menu.tsx
var menu = {
  iconName: "menu",
  width: 448,
  height: 512,
  svgPathData: "M0 64H448v48H0V64zM0 224H448v48H0V224zM448 384v48H0V384H448z",
  iconType: "fill"
};

// src/message.tsx
var message = {
  iconName: "message",
  width: 512,
  height: 512,
  svgPathData: "M128 544l0-96-128 0 0-416 512 0 0 416-224 0-160 96zm48-84.8l98.7-59.2 189.3 0 0-320-416 0 0 320 128 0 0 59.2z",
  iconType: "fill",
  fill: "none"
};

// src/messageQuestion.tsx
var messageQuestion = {
  iconName: "message-question",
  width: 512,
  height: 512,
  svgPathData: "M200.7 500.4c-12.6 7.5-36.8 22.1-72.7 43.6l0-96-128 0 0-416 512 0 0 416-224 0-87.3 52.4zM176 459.2c22.9-13.7 67.8-40.7 87.3-52.4l11.4-6.8 189.3 0 0-320-416 0 0 320 128 0 0 59.2zm80-294c-17.7 0-32 14.3-32 32l-42.4 0c0-41.1 33.3-74.4 74.4-74.4s74.4 33.3 74.4 74.4c0 33.3-19.8 52.7-37.4 62.5-5.5 3.1-11 5.4-15.8 7.1l0 18.3-42.4 0 0-53.5c2.3-.3 4.6-.6 6.9-.9 10.5-1.3 21.1-2.7 30.5-8 9-5.1 15.8-12.4 15.8-25.6 0-17.7-14.3-32-32-32zM232 312l48 0 0 48-48 0 0-48z",
  iconType: "fill",
  fill: "none"
};

// src/messageSmile.tsx
var messageSmile = {
  iconName: "message-smile",
  width: 512,
  height: 512,
  svgPathData: "M200.7 500.4c-12.6 7.5-36.8 22.1-72.7 43.6l0-96-128 0 0-416 512 0 0 416-224 0-87.3 52.4zM176 459.2c22.9-13.7 67.8-40.7 87.3-52.4l11.4-6.8 189.3 0 0-320-416 0 0 320 128 0 0 59.2zM192 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM166.6 280c22 24.6 53.9 40 89.4 40s67.4-15.4 89.4-40l35.8 32c-30.7 34.3-75.5 56-125.2 56s-94.5-21.7-125.2-56l35.8-32z",
  iconType: "fill",
  fill: "none"
};

// src/minus.tsx
var minus = {
  iconName: "minus",
  width: 448,
  height: 512,
  svgPathData: "M0 232l448 0 0 48-448 0 0-48z",
  iconType: "fill"
};

// src/moneyBill.tsx
var moneyBill = {
  iconName: "money-bill",
  width: 512,
  height: 512,
  svgPathData: "M400 112c0 35.3 28.7 64 64 64l0 160c-35.3 0-64 28.7-64 64l-288 0c0-35.3-28.7-64-64-64l0-160c35.3 0 64-28.7 64-64l288 0zM48 64l-48 0 0 384 512 0 0-384-464 0zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z",
  iconType: "fill",
  fill: "none"
};

// src/newspaper.tsx
var newspaper = {
  iconName: "newspaper",
  width: 512,
  height: 512,
  svgPathData: "M96 32l416 0 0 448-512 0 0-392 48 0 0 344 8 0c22.1 0 40-17.9 40-40L96 32zm38.4 400l329.6 0 0-352-320 0 0 312c0 14.4-3.5 28-9.6 40zM192 128l96 0 0 96-96 0 0-96zm152 48l72 0 0 48-96 0 0-48 24 0zM216 256l200 0 0 48-224 0 0-48 24 0zm0 80l200 0 0 48-224 0 0-48 24 0z",
  iconType: "fill",
  fill: "none"
};

// src/notdef.tsx
var notdef = {
  iconName: "notdef",
  width: 384,
  height: 512,
  svgPathData: "M0 0L384 0 384 512 0 512 0 0zM48 421.8L162.8 256 48 90.2 48 421.8zM77.2 464L306.8 464 192 298.2 77.2 464zm144-208L336 421.8 336 90.2 221.2 256zM306.8 48L77.2 48 192 213.8 306.8 48z",
  iconType: "fill",
  fill: "none"
};

// src/paintbrushPencil.tsx
var paintbrushPencil = {
  iconName: "paintbrush-pencil",
  width: 640,
  height: 512,
  svgPathData: "M226.4 17.9l95.1 95.1-33.9 33.9-95.1-95.1-76.1 76.1 81.9 81.9c-18.3 2.7-35.7 8.3-51.7 16.2L48.4 128 192.4-16 226.4 17.9zM417.5 429.2l105.7 29.6-29.6-105.7-32.2-32.2 33.9-33.9 41.1 41.1c31.5 112.6 50.2 179.3 56 200-20.8-5.8-87.4-24.5-200-56l-10.1-10.1c7.9-16 13.5-33.4 16.2-51.7l19 19zm95-439.1c2.1 2.1 31.8 31.8 89 89l17 17-17 17-250.6 250.6c1.1 6.7 1.6 13.5 1.6 20.4 0 70.7-57.3 128-128 128l-192 0 0-48 64 0 0-80c0-70.7 57.3-128 128-128 7 0 13.8 .6 20.4 1.6L495.5 7 512.4-9.9zM550.5 96L512.4 57.9 293.9 276.5c15.2 9.8 28.2 22.8 38.1 38.1L550.5 96zM144.4 464l80 0c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80l0 80z",
  iconType: "fill",
  fill: "none"
};

// src/paintRoller.tsx
var paintRoller = {
  iconName: "paint-roller",
  width: 512,
  height: 512,
  svgPathData: "M368 48l0 96-320 0 0-96 320 0zM48 0l-48 0 0 192 416 0 0-72 40 0 0 144-256 0 0 72-40 0 0 208 128 0 0-208-40 0 0-24 256 0 0-240-88 0 0-72-368 0zM240 384l0 112-32 0 0-112 32 0z",
  iconType: "fill",
  fill: "none"
};

// src/pen.tsx
var pen = {
  iconName: "pen",
  width: 576,
  height: 512,
  svgPathData: "M16 528c5.8-20.7 24.5-87.4 56-200L382.1 17.9 416-16C431.6-.4 468.3 36.3 526.1 94.1L560 128 526.1 161.9 216 472C103.4 503.5 36.8 522.2 16 528zm174.9-98.8L397.1 223 321 146.9 114.8 353 85.2 458.8 190.9 429.2zM431 189.1L492.1 128 416 51.9 354.9 113 431 189.1z",
  iconType: "fill",
  fill: "none"
};

// src/pencil.tsx
var pencil = {
  iconName: "pencil",
  width: 576,
  height: 512,
  svgPathData: "M31.1 473.9L16 528c20.7-5.8 87.4-24.5 200-56L526.1 161.9 560 128c-15.6-15.6-52.3-52.3-110.1-110.1L416-16 382.1 17.9 72 328 31.1 473.9zM215 405.1L138.9 329 321 146.9 397.1 223 215 405.1zm-39.5 28.4l-90.3 25.3 25.3-90.3 65 65zM492.1 128L431 189.1 354.9 113 416 51.9 492.1 128z",
  iconType: "fill",
  fill: "none"
};

// src/penToSquare.tsx
var penToSquare = {
  iconName: "pen-to-square",
  width: 576,
  height: 512,
  svgPathData: "M221.6 278.3L362 137.9c14.7 14.7 29.4 29.4 44.1 44.1l-140.4 140.4-50.4 6.3 6.3-50.4zM418 126L395.9 104 440 59.9 484.1 104 440 148.1 418 126zm134-22C502.8 54.8 450.2 2.2 440-8L406.1 25.9 176 256c-7.2 57.5-12.5 100.2-16 128 27.8-3.5 70.5-8.8 128-16L518.1 137.9 552 104zM56 64l-24 0 0 448 448 0 0-224-48 0 0 176-352 0 0-352 176 0 0-48-200 0z",
  iconType: "fill",
  fill: "none"
};

// src/plug.tsx
var plug = {
  iconName: "plug",
  width: 448,
  height: 512,
  svgPathData: "M144-32l0 128 160 0 0-128 48 0 0 128 96 0 0 48-32 0 0 80c0 97.9-73.3 178.7-168 190.5l0 97.5-48 0 0-97.5C105.3 402.7 32 321.9 32 224l0-80-32 0 0-48 96 0 0-128 48 0zM80 144l0 80c0 79.5 64.5 144 144 144s144-64.5 144-144l0-80-288 0z",
  iconType: "fill",
  fill: "none"
};

// src/plus.tsx
var plus = {
  iconName: "plus",
  width: 448,
  height: 512,
  svgPathData: "M248 56l0-24-48 0 0 200-200 0 0 48 200 0 0 200 48 0 0-200 200 0 0-48-200 0 0-176z",
  iconType: "fill"
};

// src/question.tsx
var question = {
  iconName: "question",
  width: 320,
  height: 512,
  svgPathData: "M48 160C48 98.1 98.1 48 160 48S272 98.1 272 160c0 38.7-20.1 76.3-56 97l-68 39.3-12 6.9 0 80.8 48 0 0-53.1 56-32.3c51.3-29.6 79.9-83.4 80-138.5l0 0C320 71.6 248.4 0 160 0S0 71.6 0 160l0 32 48 0 0-32zM188 504l0-56-56 0 0 56 56 0z",
  iconType: "fill",
  fill: "none"
};

// src/refreshArrow.tsx
var refreshArrow = {
  iconName: "refresh-arrow",
  width: 512,
  height: 512,
  svgPathData: "M472 224h24V200 56 32H448V56v80.1l-20-23.5C387 63.4 325.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c50.4 0 97-16.7 134.4-44.8l-28.8-38.4C332.2 418.9 295.7 432 256 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c54.3 0 102.9 24.6 135.2 63.4l.1 .2 0 0L418.9 176H328 304v48h24H472z",
  iconType: "fill"
};

// src/refreshCircle.tsx
var refreshCircle = {
  iconName: "refresh-circle",
  width: 20,
  height: 19,
  svgPathData: "M3.67188 6.84375L1.91406 6.10156C3.24219 2.97656 6.36719 0.75 10 0.75C12.0312 0.75 13.9844 1.57031 15.4297 3.01562L15.6641 3.21094L16.4844 2.39062L17.8125 1.0625L19.1016 2.39062L19.375 2.625V6.375V8.25H17.5H13.75L13.4766 8.01562L12.1875 6.6875L13.4766 5.39844L14.3359 4.53906L14.1016 4.34375C13.0078 3.25 11.5234 2.625 10 2.625C7.14844 2.625 4.6875 4.38281 3.67188 6.84375ZM16.2891 12.2344L18.0469 12.9766C16.6797 16.0625 13.5938 18.25 10 18.25C7.92969 18.25 5.97656 17.4688 4.53125 16.0234L4.33594 15.7891L3.47656 16.6484L2.1875 17.9375L0.859375 16.6484L0.625 16.375V12.625V10.75H2.5H6.25L6.48438 11.0234L7.8125 12.3125L6.48438 13.6406L5.66406 14.4609L5.85938 14.6953C6.95312 15.7891 8.4375 16.375 10 16.375C12.8125 16.375 15.2734 14.6953 16.2891 12.2344ZM15.1172 6.375H17.5V4.03125L15.1172 6.375ZM4.84375 12.625H2.5V15.0078L4.84375 12.625Z",
  iconType: "fill",
  fill: "none"
};

// src/rightArrow.tsx
var rightArrow = {
  iconName: "right-arrow",
  width: 448,
  height: 512,
  svgPathData: "M429.8 273l17-17-17-17L276.2 85.4l-17-17-33.9 33.9 17 17L354.9 232 24 232 0 232l0 48 24 0 330.8 0L242.2 392.6l-17 17 33.9 33.9 17-17L429.8 273z",
  iconType: "fill"
};

// src/rocketLaunch.tsx
var rocketLaunch = {
  iconName: "rocket-launch",
  width: 512,
  height: 512,
  svgPathData: "M511.9 19.3L508.8 3.6 493.1 .5c-45-9-114-14.7-180.7 19.7-40 20.7-77.3 54.8-107.7 107.8L96.4 128C45.2 213.3 13.2 266.7 .4 288l158.1 0 1 1 64 64 1 1 0 158.1c21.3-12.8 74.7-44.8 160-96l0-108.3c53.1-30.4 87.2-67.7 107.8-107.7 34.4-66.7 28.7-135.7 19.7-180.7zM272.4 352.7c23.3-6.4 44.6-13.6 64-21.6l0 57.8-64 38.4 0-74.5zM181.3 176c-8 19.4-15.2 40.7-21.6 64l-74.5 0 38.4-64 57.8 0zM334.4 62.8c45.9-23.7 94.6-23.8 133.2-18.1 5.8 38.6 5.6 87.3-18.1 133.2-25.7 49.9-81.9 101.3-201.7 131.5l-45-45c30.2-119.9 81.7-176 131.5-201.7zm74 81.2a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM152.8 473.6c31.5-31.5 31.5-82.5 0-114s-82.5-31.5-114 0c-45.3 45.3-38 152-38 152s106.7 7.3 152-38zm-40.6-32C95.7 458.1 57 455.4 57 455.4s-2.7-38.7 13.8-55.2c11.4-11.4 30-11.4 41.4 0s11.4 30 0 41.4z",
  iconType: "fill",
  fill: "none"
};

// src/rulerTriangle.tsx
var rulerTriangle = {
  iconName: "ruler-triangle",
  width: 576,
  height: 512,
  svgPathData: "M64.3-29.3l0 509.3 509.3 0-48-48-413.3-413.3-48-48zm48 115.9L188 162.3c-14.4 14.4-27 27-37.7 37.7l33.9 33.9c10.7-10.7 23.2-23.2 37.7-37.7l46.1 46.1-21.7 21.7 33.9 33.9 17-17 4.7-4.7 46.1 46.1c-14.4 14.4-27 27-37.7 37.7l33.9 33.9c10.7-10.7 23.2-23.2 37.7-37.7l75.7 75.7-345.4 0 0-345.4zm80 185.1l0 80.2 80.2 0-80.2-80.2z",
  iconType: "fill",
  fill: "none"
};

// src/sb.tsx
var sb = {
  iconName: "sb",
  width: 50,
  height: 35,
  svgPathData: "M27.413 30.338c-.272 0-.372-.102-.372-.376V4.037c0-.305.07-.374.372-.374h8.372c1.53 0 3.678.326 5.223 1.884 1.095 1.104 1.698 2.658 1.698 4.378 0 3.621-4.731 6.485-4.731 6.485s5.26 1.352 6.613 3.68c.569.852.858 1.916.858 3.163 0 1.994-.69 3.763-1.94 4.981-1.414 1.376-3.554 2.104-6.188 2.104h-9.905zm16.585-14.914c1.323-1.5 1.966-3.3 1.966-5.499 0-2.582-.938-4.948-2.64-6.664-1.849-1.864-4.455-2.85-7.539-2.85h-8.372c-2.104 0-3.63 1.525-3.63 3.626v25.925c0 2.067 1.56 3.626 3.63 3.626h9.905c3.502 0 6.429-1.047 8.463-3.028 1.885-1.834 2.923-4.43 2.923-7.307 0-1.9-.473-3.57-1.405-4.965-.79-1.183-1.9-2.146-3.301-2.864zM18.715 17.772a18.254 18.254 0 00-2.975-1.873 44.76 44.76 0 00-3.27-1.498 41.894 41.894 0 01-2.986-1.35c-.901-.454-1.636-1.003-2.203-1.646-.568-.642-.852-1.38-.852-2.213 0-1.12.455-2.019 1.366-2.7.91-.681 2.132-1.021 3.665-1.021.79 0 1.574.107 2.356.323.782.215 1.392.434 1.833.658.44.222.956.511 1.548.864.44.247.842.37 1.206.37.607 0 1.085-.34 1.434-1.017l.843-1.515c.227-.392.342-.76.342-1.108 0-.587-.31-1.1-.93-1.537-.86-.633-2.054-1.21-3.58-1.73C14.986.26 13.348 0 11.595 0 9.51 0 7.63.387 5.953 1.16c-1.676.775-3.006 1.89-3.988 3.347C.983 5.964.492 7.632.492 9.51c0 1.09.172 2.092.517 3.008.345.915.813 1.695 1.405 2.337a12.56 12.56 0 002.033 1.77c.764.538 1.565 1.01 2.404 1.42.839.407 1.683.793 2.53 1.157.849.363 1.659.734 2.431 1.111.772.379 1.457.772 2.056 1.18a4.95 4.95 0 011.42 1.441c.348.553.522 1.162.522 1.828 0 1.12-.443 2.027-1.329 2.723-.886.696-2.086 1.044-3.6 1.044-2.156 0-4.379-.819-6.67-2.457-.478-.291-.904-.436-1.277-.436a.834.834 0 00-.204.022c-.423.06-.815.34-1.178.836L.51 27.964c-.302.392-.469.76-.499 1.108a.58.58 0 000 .226c0 .256.053.474.159.655.136.242.348.475.635.701 1.087.829 2.519 1.594 4.296 2.294C6.877 33.65 8.804 34 10.88 34c1.671 0 3.2-.256 4.585-.766 1.386-.511 2.534-1.21 3.445-2.097a9.209 9.209 0 002.101-3.088 9.666 9.666 0 00.734-3.764c0-1.422-.281-2.689-.845-3.801-.563-1.112-1.292-2.017-2.186-2.712",
  iconType: "fill"
};

// src/screwdriverWrench.tsx
var screwdriverWrench = {
  iconName: "screwdriver-wrench",
  width: 576,
  height: 512,
  svgPathData: "M176.1 105.7l-89.9-59.9-8.4 8.4 59.9 89.9 38.3 0 0-38.3zm48-25.7l0 78.1 97.9 97.9 94.1 0c99.4 99.4 152.7 152.7 160 160l-128 128c-7.3-7.3-60.6-60.6-160-160l0-94.1-97.9-97.9-78.1 0-96-144 64-64 144 96zm112 284.1l112 112 60.1-60.1-112-112-60.1 0 0 60.1zM180.7 250.3l33.9 33.9-125.1 125.1-22.6 22.6 45.3 45.3c1.3-1.3 44-44 128-128l0 67.9c-121.5 121.5-116.4 116.4-128 128-.9-.9-33-33-96.2-96.2L-1 432c3.7-3.7 98.1-98.2 181.7-181.7zm155.5-48.2l0-92.1 7-7 53.3-53.3c-6.6-1.1-13.4-1.7-20.3-1.7-44.5 0-83.3 24.2-104 60.1l0-72C300.7 13.5 336.9 0 376.1 0l.8 0c26.8 .1 52.2 6.5 74.7 17.9l1.2 .6c9.3 4.8 18 10.3 26.2 16.7-5.4 5.4-37 37-94.8 94.8l0 30.1 30.1 0c57.9-57.9 89.5-89.5 94.8-94.8 6.3 8.2 11.9 16.9 16.7 26.2l.6 1.2c10.4 20.6 16.6 43.6 17.7 67.9 .1 2.5 .2 5 .2 7.6 0 41.3-14.9 79.2-39.7 108.4l-34.1-34.1c16.1-20.4 25.8-46.3 25.8-74.3 0-6.9-.6-13.7-1.7-20.3l-53.3 53.3-7 7-92.1 0-5.8-5.8z",
  iconType: "fill",
  fill: "none"
};

// src/search.tsx
var search = {
  iconName: "search",
  width: 576,
  height: 512,
  svgPathData: "M400.4 208a160 160 0 1 0 -320 0 160 160 0 1 0 320 0zM369.6 371.1c-35.5 28.1-80.3 44.9-129.1 44.9-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1l133.9 133.9 17 17-33.9 33.9-17-17-133.9-133.9z",
  iconType: "fill"
};

// src/shieldCheck.tsx
var shieldCheck = {
  iconName: "shield-check",
  width: 512,
  height: 512,
  svgPathData: "M64.1 126L256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8-28.2 64.9-77.1 127.7-158.1 164.8-81.1-37.1-129.9-99.9-158.1-164.8-26.9-61.9-34.8-125.3-33.8-168.8zm431.4-13L494.3 92.5 475.1 85 267.6 4.5 256 0 244.5 4.5 37 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.2 91 150 189.4 192.6l12.7 5.5 12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9zM353.1 176.4l-40.7-25.4c-.4 .6-25.1 40.1-74.2 118.7-20.1-26.8-33.9-45.2-41.4-55.2l-38.4 28.8c4 5.3 24.8 33.1 62.4 83.2l7.2 9.6 25.3 0 7-11.3 80-128 12.7-20.4z",
  iconType: "fill",
  fill: "none"
};

// src/shieldHeart.tsx
var shieldHeart = {
  iconName: "shield-heart",
  width: 512,
  height: 512,
  svgPathData: "M64.1 126L256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8-28.2 64.9-77.1 127.7-158.1 164.8-81.1-37.1-129.9-99.9-158.1-164.8-26.9-61.9-34.8-125.3-33.8-168.8zm431.4-13L494.3 92.5 475.1 85 267.6 4.5 256 0 244.5 4.5 37 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.2 91 150 189.4 192.6l12.7 5.5 12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9zM249.6 183.5c-11.1-14.8-28.5-23.5-46.9-23.5-32.4 0-58.7 26.3-58.7 58.7l0 5.3c0 64 112 128 112 128s112-64 112-128l0-5.3c0-32.4-26.3-58.7-58.7-58.7-18.5 0-35.9 8.7-46.9 23.5l-6.4 8.5-6.4-8.5z",
  iconType: "fill",
  fill: "none"
};

// src/simplybusiness.tsx
var simplybusiness = {
  iconName: "simplybusiness",
  width: 120,
  height: 34,
  svgPathData: "M27.413 30.338c-.272 0-.372-.102-.372-.376V4.037c0-.305.07-.374.372-.374h8.372c1.53 0 3.678.326 5.223 1.884 1.095 1.104 1.698 2.658 1.698 4.378 0 3.621-4.731 6.485-4.731 6.485s5.26 1.352 6.613 3.68c.569.852.858 1.916.858 3.163 0 1.994-.69 3.763-1.94 4.981-1.414 1.376-3.554 2.104-6.188 2.104h-9.905zm16.585-14.914c1.323-1.5 1.966-3.3 1.966-5.499 0-2.582-.938-4.948-2.64-6.664-1.849-1.864-4.455-2.85-7.539-2.85h-8.372c-2.104 0-3.63 1.525-3.63 3.626v25.925c0 2.067 1.56 3.626 3.63 3.626h9.905c3.502 0 6.429-1.047 8.463-3.028 1.885-1.834 2.923-4.43 2.923-7.307 0-1.9-.473-3.57-1.405-4.965-.79-1.183-1.9-2.146-3.301-2.864zM18.715 17.772a18.254 18.254 0 00-2.975-1.873 44.76 44.76 0 00-3.27-1.498 41.894 41.894 0 01-2.986-1.35c-.901-.454-1.636-1.003-2.203-1.646-.568-.642-.852-1.38-.852-2.213 0-1.12.455-2.019 1.366-2.7.91-.681 2.132-1.021 3.665-1.021.79 0 1.574.107 2.356.323.782.215 1.392.434 1.833.658.44.222.956.511 1.548.864.44.247.842.37 1.206.37.607 0 1.085-.34 1.434-1.017l.843-1.515c.227-.392.342-.76.342-1.108 0-.587-.31-1.1-.93-1.537-.86-.633-2.054-1.21-3.58-1.73C14.986.26 13.348 0 11.595 0 9.51 0 7.63.387 5.953 1.16c-1.676.775-3.006 1.89-3.988 3.347C.983 5.964.492 7.632.492 9.51c0 1.09.172 2.092.517 3.008.345.915.813 1.695 1.405 2.337a12.56 12.56 0 002.033 1.77c.764.538 1.565 1.01 2.404 1.42.839.407 1.683.793 2.53 1.157.849.363 1.659.734 2.431 1.111.772.379 1.457.772 2.056 1.18a4.95 4.95 0 011.42 1.441c.348.553.522 1.162.522 1.828 0 1.12-.443 2.027-1.329 2.723-.886.696-2.086 1.044-3.6 1.044-2.156 0-4.379-.819-6.67-2.457-.478-.291-.904-.436-1.277-.436a.834.834 0 00-.204.022c-.423.06-.815.34-1.178.836L.51 27.964c-.302.392-.469.76-.499 1.108a.58.58 0 000 .226c0 .256.053.474.159.655.136.242.348.475.635.701 1.087.829 2.519 1.594 4.296 2.294C6.877 33.65 8.804 34 10.88 34c1.671 0 3.2-.256 4.585-.766 1.386-.511 2.534-1.21 3.445-2.097a9.209 9.209 0 002.101-3.088 9.666 9.666 0 00.734-3.764c0-1.422-.281-2.689-.845-3.801-.563-1.112-1.292-2.017-2.186-2.712M52.97 10.428l.38-.552c.277-.38.57-.397 1.004-.156.398.277 1.28.898 2.492.898 1.142 0 1.834-.57 1.834-1.398 0-2.331-5.728-1.848-5.728-5.663 0-2.159 1.8-3.557 4.136-3.557 1.454 0 2.648.552 3.167.932.38.277.433.605.225.984l-.312.57c-.26.5-.623.432-.986.242-.502-.294-1.177-.674-2.129-.674-1.142 0-1.869.553-1.869 1.382 0 2.296 5.728 1.71 5.728 5.611 0 1.986-1.488 3.626-4.066 3.626-1.748 0-3.167-.777-3.773-1.243-.277-.242-.45-.535-.104-1.002M62.61 4.386c0-.467.241-.726.709-.726h.762c.467 0 .709.26.709.726v7.354c0 .484-.242.726-.71.726h-.761c-.468 0-.71-.242-.71-.726V4.386zm0-2.936V.932c0-.466.241-.725.709-.725h.762c.467 0 .726.26.726.725v.518c0 .466-.26.708-.726.708h-.762c-.468 0-.71-.242-.71-.708zM66.97 4.386c0-.467.243-.726.71-.726h.675c.467 0 .71.26.71.726v.535c0 .19-.035.397-.035.397h.035c.433-.864 1.505-1.865 2.89-1.865 1.332 0 2.215.621 2.579 1.813h.034c.468-.915 1.627-1.813 3.011-1.813 1.835 0 2.89 1.036 2.89 3.35v4.937c0 .484-.259.726-.726.726h-.745c-.484 0-.726-.242-.726-.726V7.217c0-1.001-.19-1.761-1.212-1.761-1.488 0-2.25 1.52-2.25 3.056v3.228c0 .484-.242.726-.71.726h-.76c-.468 0-.728-.242-.728-.726V7.217c0-.95-.138-1.761-1.176-1.761-1.558 0-2.285 1.588-2.285 3.056v3.228c0 .484-.242.726-.71.726h-.76c-.468 0-.71-.242-.71-.726V4.386zM86.84 10.826c1.21 0 2.215-.984 2.215-2.728 0-1.675-.9-2.763-2.181-2.763-1.142 0-2.233.829-2.233 2.78 0 1.364.762 2.71 2.199 2.71zm-4.327-6.44c0-.467.26-.726.727-.726h.554c.467 0 .71.26.71.604v.398c0 .19-.018.345-.018.345h.034s.78-1.554 2.838-1.554c2.389 0 3.929 1.882 3.929 4.61 0 2.797-1.73 4.61-4.05 4.61-1.834 0-2.543-1.347-2.543-1.347h-.035s.052.31.052.76v3.108c0 .483-.243.725-.727.725h-.744c-.468 0-.727-.242-.727-.725V4.386zM92.932.932c0-.466.242-.725.71-.725h.761c.467 0 .71.259.71.725v8.616c0 .863.363 1.018.692 1.053.312.035.536.225.536.622v.587c0 .448-.208.742-.726.742-1.177 0-2.683-.31-2.683-2.832V.932zM97.83 14.123c.156.07.364.156.623.156.64 0 1.142-.553 1.402-1.174l.329-.777-3.358-7.822c-.225-.5 0-.846.554-.846h.935c.432 0 .674.19.813.587l1.661 4.49c.156.466.33 1.19.33 1.19h.034s.155-.69.294-1.156l1.558-4.506c.12-.415.38-.605.813-.605h.865c.537 0 .762.328.589.829l-3.635 9.289c-.606 1.605-1.886 2.313-3.184 2.313-.484 0-.917-.138-1.228-.258-.416-.156-.52-.535-.33-.933l.156-.38c.19-.397.485-.466.78-.397M58.109 30.458c1.142 0 1.782-.742 1.782-1.778 0-1.02-.657-1.762-1.782-1.762h-2.388v3.54h2.388zm-.208-5.335c.97 0 1.506-.69 1.506-1.571s-.52-1.52-1.558-1.52h-2.128v3.09h2.18zm-4.395-4.282c0-.466.242-.725.71-.725h3.668c2.215 0 3.807 1.14 3.807 3.16 0 1.139-.554 2.123-1.488 2.624v.034c1.332.398 1.973 1.64 1.973 2.884 0 2.451-1.956 3.556-4.24 3.556h-3.72c-.468 0-.71-.241-.71-.725V20.841zM63.855 24.294c0-.466.26-.725.727-.725h.744c.485 0 .727.259.727.725v4.49c0 1.07.277 1.795 1.367 1.795 1.592 0 2.475-1.398 2.475-2.97v-3.315c0-.466.242-.725.727-.725h.744c.467 0 .727.259.727.725v7.355c0 .484-.26.726-.727.726h-.675c-.467 0-.71-.242-.71-.726v-.518c0-.207.035-.397.035-.397h-.034c-.416.898-1.558 1.848-3.064 1.848-1.886 0-3.063-.95-3.063-3.35v-4.938zM73.876 30.7l.208-.31c.26-.364.554-.398.987-.174.415.225 1.073.605 1.973.605.76 0 1.228-.346 1.228-.898 0-1.433-4.378-.898-4.378-3.92 0-1.726 1.523-2.641 3.374-2.641 1.178 0 1.99.38 2.458.638.398.208.45.57.26.968l-.174.31c-.207.414-.536.466-.969.276-.38-.172-.951-.431-1.679-.431-.76 0-1.194.31-1.194.863 0 1.45 4.379.88 4.379 3.885 0 1.554-1.315 2.71-3.357 2.71a5.166 5.166 0 01-2.942-.897c-.398-.224-.433-.605-.174-.984M81.994 24.294c0-.466.242-.725.709-.725h.762c.467 0 .71.259.71.725v7.355c0 .484-.243.726-.71.726h-.762c-.467 0-.71-.242-.71-.726v-7.355zm0-2.935v-.518c0-.466.242-.725.709-.725h.762c.467 0 .726.259.726.725v.518c0 .466-.26.708-.726.708h-.762c-.467 0-.71-.242-.71-.708zM86.355 24.294c0-.466.242-.725.71-.725h.674c.468 0 .71.259.71.725v.535c0 .19-.035.398-.035.398h.035a3.442 3.442 0 013.132-1.865c1.956 0 3.08 1.018 3.08 3.35v4.937c0 .484-.242.726-.726.726h-.744c-.468 0-.727-.242-.727-.726V27.16c0-1.07-.277-1.795-1.384-1.795-1.558 0-2.544 1.294-2.544 2.883v3.401c0 .484-.243.726-.71.726h-.761c-.468 0-.71-.242-.71-.726v-7.355zM102.398 26.97c-.034-1.226-.778-1.95-1.782-1.95-1.125 0-1.92.776-2.128 1.95h3.91zm-1.73-3.608c2.51 0 3.911 1.778 3.911 4.195 0 .38-.329.743-.761.743h-5.382c.138 1.588 1.314 2.417 2.647 2.417.814 0 1.489-.311 1.904-.57.433-.207.744-.155.97.242l.207.345c.208.398.138.743-.242.967a5.59 5.59 0 01-2.994.88c-2.925 0-4.742-2.106-4.742-4.61 0-2.71 1.834-4.61 4.482-4.61zM105.791 30.7l.208-.31c.26-.364.554-.398.987-.174.415.225 1.072.605 1.972.605.762 0 1.229-.346 1.229-.898 0-1.433-4.378-.898-4.378-3.92 0-1.726 1.523-2.641 3.374-2.641 1.177 0 1.99.38 2.457.638.399.208.45.57.26.968l-.173.31c-.207.414-.536.466-.969.276-.38-.172-.952-.431-1.679-.431-.761 0-1.193.31-1.193.863 0 1.45 4.378.88 4.378 3.885 0 1.554-1.316 2.71-3.358 2.71a5.167 5.167 0 01-2.942-.897c-.398-.224-.432-.605-.173-.984M113.528 30.7l.207-.31c.26-.364.554-.398.987-.174.415.225 1.073.605 1.973.605.76 0 1.228-.346 1.228-.898 0-1.433-4.378-.898-4.378-3.92 0-1.726 1.523-2.641 3.375-2.641 1.176 0 1.99.38 2.457.638.398.208.45.57.26.968l-.173.31c-.208.414-.537.466-.97.276-.38-.172-.951-.431-1.678-.431-.762 0-1.194.31-1.194.863 0 1.45 4.378.88 4.378 3.885 0 1.554-1.315 2.71-3.357 2.71a5.167 5.167 0 01-2.942-.897c-.398-.224-.433-.605-.173-.984",
  iconType: "fill"
};

// src/sparkles.tsx
var sparkles = {
  iconName: "sparkles",
  width: 640,
  height: 512,
  svgPathData: "M480 32l-72 32 72 32 32 72 32-72 72-32-72-32-32-72-32 72zM288 320c60.9-27.1 108.9-48.4 144-64-35.1-15.6-83.1-36.9-144-64-27.1-60.9-48.4-108.9-64-144-15.6 35.1-36.9 83.1-64 144-60.9 27.1-108.9 48.4-144 64 35.1 15.6 83.1 36.9 144 64 27.1 60.9 48.4 108.9 64 144 15.6-35.1 36.9-83.1 64-144zm-64 25.8c-15.5-34.9-24.7-55.7-27.6-62.2-6.5-2.9-27.2-12.1-62.2-27.6 34.9-15.5 55.7-24.7 62.2-27.6 2.9-6.5 12.1-27.2 27.6-62.2 15.5 34.9 24.7 55.7 27.6 62.2 6.5 2.9 27.2 12.1 62.2 27.6-34.9 15.5-55.7 24.7-62.2 27.6-2.9 6.5-12.1 27.2-27.6 62.2zM480 344l-32 72-72 32 72 32 32 72 32-72 72-32-72-32-32-72z",
  iconType: "fill",
  fill: "none"
};

// src/sprinkler.tsx
var sprinkler = {
  iconName: "sprinkler",
  width: 512,
  height: 512,
  svgPathData: "M48 24A24 24 0 1 0 0 24 24 24 0 1 0 48 24zM24 152a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM88 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-32a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm312 80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24-80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM464 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM424 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-40-32a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM240 362.9c-4.9-4.5-26.3-24.1-64.2-58.9l160.5 0c-38 34.8-59.4 54.4-64.2 58.9l0 101.1-32 0 0-101.1zM232 256l-136 0 0 40 8.7 8 87.3 80 0 128 128 0 0-128 87.3-80 8.7-8 0-40-136 0 0-192-48 0 0 192z",
  iconType: "fill",
  fill: "none"
};

// src/square.tsx
var square = {
  iconName: "square",
  width: 448,
  height: 512,
  svgPathData: "M400 80l0 352-352 0 0-352 352 0zM48 32l-48 0 0 448 448 0 0-448-400 0z",
  iconType: "fill",
  fill: "none"
};

// src/squareTick.tsx
var squareTick = {
  iconName: "square-tick",
  width: 448,
  height: 512,
  svgPathData: "M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM337 209L209 337l-17 17-17-17-64-64-17-17L128 222.1l17 17 47 47L303 175l17-17L353.9 192l-17 17z",
  iconType: "fill",
  fill: "none"
};

// src/star.tsx
var star = {
  iconName: "star",
  width: 576,
  height: 512,
  svgPathData: "M288.2-52.8c5.9 11.7 36.8 72.1 92.6 181.4 121.2 19.3 188.2 29.9 201.1 32-9.2 9.3-57.2 57.3-143.9 144.1 19.1 121.2 29.7 188.2 31.7 201.2-11.7-5.9-72.2-36.7-181.5-92.3-109.3 55.6-169.8 86.4-181.5 92.3 2-12.9 12.6-80 31.7-201.2-86.7-86.8-134.7-134.8-143.9-144.1 12.9-2.1 80-12.7 201.1-32 55.8-109.3 86.6-169.7 92.6-181.4zm0 105.6l-55.4 108.5-5.6 10.9-12.1 1.9-120.3 19.1 86.1 86.2 8.6 8.6-1.9 12.1-19 120.3 108.6-55.2 10.9-5.5 10.9 5.5 108.6 55.2-19-120.3-1.9-12.1 8.6-8.6 86.1-86.2-120.3-19.1-12.1-1.9-5.6-10.9-55.4-108.5z",
  iconType: "fill"
};

// src/sterlingSign.tsx
var sterlingSign = {
  iconName: "sterling-sign",
  width: 320,
  height: 512,
  svgPathData: "M174.1 34C75.1 34 9.3 136.3 50.3 226.4l6.2 13.6-56.5 0 0 48 68.8 0c1 23.9-5.1 48-18.1 68.9l-39 62.4-3.6 5.8 0 54.9 312 0 0-48-259.7 0 31.1-49.7c17.9-28.6 26.5-61.5 25.5-94.3l171.2 0 0-48-179.8 0c-1.8-5.5-4-11-6.4-16.3L94 206.5C67.4 148.2 110 82 174.1 82l9.2 0c21 0 41.3 7.1 57.7 20.1 10.3 8.1 21.9 17.3 34.9 27.6l29.8-37.6c-13-10.3-24.6-19.5-34.9-27.6-24.9-19.7-55.8-30.4-87.5-30.4l-9.2 0z",
  iconType: "fill",
  fill: "none"
};

// src/store.tsx
var store = {
  iconName: "store",
  width: 576,
  height: 512,
  svgPathData: "M78.6 32l418.5 0 5.6 16.1 47.6 136 7.4 21.1c-12.9 5.6-28.1 12.1-45.6 19.7l0 255.1-448 0 0-255c-17.8-7.7-33.2-14.3-46-19.9L25.4 184.1 73 48.1 78.6 32zM287.8 217.6l-55.8 20.9-9.2 3.5-9-4-44.8-20-57 20.6 0 81.5 352 0 0-81.4-.2-.1-57.3-20.7-44.8 20-9 4-9.2-3.5-55.8-20.9zM112.7 80l-34.6 98.8 26.3 11.4 43.2-15.6 9.5-94.6-44.5 0zM380 177.2l-9.7-97.2-58.3 0 0 95.4 39.2 14.7 28.8-12.9zm48-2.6l43.2 15.6 26.3-11.4-34.6-98.8-44.5 0 9.5 94.6zM112 368l0 64 352 0 0-64-352 0zM263.6 175.4l0-95.4-58.3 0-9.7 97.2 28.8 12.9 39.2-14.7z",
  iconType: "fill",
  fill: "none"
};

// src/tag.tsx
var tag = {
  iconName: "tag",
  width: 576,
  height: 512,
  svgPathData: "M72.4 16l-24 0 0 257.9 7 7 224 224 17 17 17-17 224-224 17-17-17-17-224-224-7-7-233.9 0zm24 238.1l0-190.1 190.1 0 200 200-190.1 190.1-200-200zm80-78.1a32 32 0 1 0 0-64 32 32 0 1 0 0 64z",
  iconType: "fill",
  fill: "none"
};

// src/telephone.tsx
var telephone = {
  iconName: "telephone",
  width: 512,
  height: 512,
  svgPathData: "M304.3 387.5l-31.9-18.4c-53.8-31-98.6-75.8-129.6-129.6l-18.4-31.9 26-26 33.2-33.2L146 54.2 48.1 72c4.2 214.5 177.4 387.6 391.9 391.9L457.7 366l-94.2-37.7-33.2 33.2-26 26zM352 272l160 64L480 512H448C200.6 512 0 311.4 0 64L0 32 176 0l64 160-55.6 55.6c26.8 46.5 65.5 85.2 112 112L352 272z",
  iconType: "fill"
};

// src/thumbsUp.tsx
var thumbsUp = {
  iconName: "thumbs-up",
  width: 512,
  height: 512,
  svgPathData: "M225.7-16.6l100.2 50.1 21.4 10.8-49.9 99.8 182.6 0 0 160-16 0 0 64-16 0 0 64-16 0 0 48-214.9 0-5.8-3.6-13.6-8.5 0 0-53.6-33.5 0 45.7-144 0 0-336 118.6 0 49.9-99.8 0 0c19.1-38.2 31-62 35.8-71.5l21.5 10.7zM48 432l48 0 0-240-48 0 0 240zM211.4 65.7l0 0-67.3 134.8 0 177.3 15 9.4 64 40 0 0 7.8 4.9 153.2 0 0-48 16 0 0-64 16 0 0-64 16 0 0-64-212.2 0c6.8-13.7 27.9-55.8 63.1-126.3L225.7 37 211.4 65.7z",
  iconType: "fill",
  fill: "none"
};

// src/tick.tsx
var tick = {
  iconName: "tick",
  width: 512,
  height: 512,
  svgPathData: "M489.9 82.5l-14 19.5-264 368-16.5 23-20-20-136-136-17-17 33.9-33.9 17 17 116 116 247.5-345 14-19.5 39 28z",
  iconType: "fill"
};

// src/tree.tsx
var tree = {
  iconName: "tree",
  width: 512,
  height: 512,
  svgPathData: "M274.4-23.5l136 160 33.6 39.5-65.7 0c49.7 68.6 80.7 111.2 92.8 128l-73.9 0c60.4 81.8 95.9 129.7 106.4 144l-223.6 0 0 96-48 0 0-96-223.6 0c10.5-14.2 46-62.3 106.4-144L41 304c12.1-16.8 43.1-59.4 92.8-128l-65.7 0 33.6-39.5 136-160 18.3-21.5 18.3 21.5zM171.9 128l56 0c-12.2 16.8-43.1 59.4-92.8 128l74.9 0c-10.5 14.2-46 62.3-106.4 144l304.9 0c-60.4-81.8-95.9-129.7-106.4-144l74.9 0c-49.7-68.6-80.6-111.2-92.8-128l56 0-84.1-99-84.1 99z",
  iconType: "fill",
  fill: "none"
};

// src/truck.tsx
var truck = {
  iconName: "truck",
  width: 576,
  height: 512,
  svgPathData: "M48 80l0 320 19.3 0c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64l102.6 0c4.9-17.4 15.1-32.7 28.7-43.9L368 80 48 80zM67.3 448l-67.3 0 0-416 416 0 0 96 81.9 0 7 7 64 64 7 7 0 241.9-67.3 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64l-102.6 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64zM416 256l112 0 0-30.1-49.9-49.9-62.1 0 0 80zm0 48l0 32.4c2.6-.2 5.3-.4 8-.4 40.3 0 74.2 27.1 84.7 64l19.3 0 0-96-112 0zM152 464a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm272 0a40 40 0 1 0 0-80 40 40 0 1 0 0 80z",
  iconType: "fill",
  fill: "none"
};

// src/user.tsx
var user = {
  iconName: "user",
  width: 448,
  height: 512,
  svgPathData: "M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM50.2 512l49.2-160 249.1 0 49.2 160 50.2 0-64-208-320 0-64 208 50.2 0zM224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256z",
  iconType: "fill"
};

// src/userHelmetSafety.tsx
var userHelmetSafety = {
  iconName: "user-helmet-safety",
  width: 448,
  height: 512,
  svgPathData: "M256-32l-64 0 0 96-32 0 0-70.9C123.9 14 99 52 96.2 96l-24.2 0 0 48 24 0c0 70.7 57.3 128 128 128s128-57.3 128-128l24 0 0-48-24.2 0C349 52 324.1 14 288-6.9l0 70.9-32 0 0-96zm48 176c0 44.2-35.8 80-80 80s-80-35.8-80-80l160 0zM98.6 368l250.8 0 48 144 50.6 0-64-192-320 0-64 192 50.6 0 48-144z",
  iconType: "fill",
  fill: "none"
};

// src/users.tsx
var users = {
  iconName: "users",
  width: 640,
  height: 512,
  svgPathData: "M384 128a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-176 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm252.8 76c5.9 2.6 12.4 4 19.2 4 26.5 0 48-21.5 48-48s-21.5-48-48-48l-.8 0c-1.6-16.6-5.8-32.4-12.1-47.1 4.2-.6 8.6-.9 12.9-.9 53 0 96 43 96 96s-43 96-96 96c-17.7 0-34.3-4.8-48.6-13.2 11.7-11.3 21.6-24.4 29.4-38.8zM208.6 242.8c-14.2 8.4-30.8 13.2-48.6 13.2-53 0-96-43-96-96s43-96 96-96c4.4 0 8.7 .3 12.9 .9-6.3 14.7-10.5 30.6-12.1 47.1l-.8 0c-26.5 0-48 21.5-48 48s21.5 48 48 48c6.8 0 13.3-1.4 19.2-4 7.8 14.4 17.7 27.5 29.4 38.8zM432 288l69.8 192-51.1 0-52.4-144-156.8 0-52.4 144-51.1 0 69.8-192 224 0zM151.2 304l-17.3 48-36.3 0-46.5 128-51.1 0 64-176 87.2 0zm354.8 48l-17.3-48 87.2 0 64 176-51.1 0-46.5-128-36.3 0z",
  iconType: "fill",
  fill: "none"
};

// src/userShield.tsx
var userShield = {
  iconName: "user-shield",
  width: 576,
  height: 512,
  svgPathData: "M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM50.2 512l49.2-160 140.5 0 0-48-176 0-64 208 50.2 0zM224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM462 530.8c69.3-30.8 114-99.6 114-175.5l0-51.2-144-48-144 48 0 51.2c0 75.9 44.7 144.6 114 175.5l30 13.3 30-13.3zm-30-39.2l0-184.9 96 32 0 16.6c0 56.9-33.5 108.5-85.5 131.6L432 491.6z",
  iconType: "fill",
  fill: "none"
};

// src/utensils.tsx
var utensils = {
  iconName: "utensils",
  width: 448,
  height: 512,
  svgPathData: "M8.1 165.3L26.5 0 74.8 0 56 169.3 56 184c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-14.7-15.9-142.7-3-26.7 48.3 0 2.4 21.3 16 144 .1 1.3 0 17.3c0 48.6-39.4 88-88 88l-8 0 0 240-48 0 0-240-8 0c-48.6 0-88-39.4-88-88l0-17.3 .1-1.3zM104 24l0-24 48 0 0 192-48 0 0-168zM336 176l0 128 64 0 0-248.9c-7.1 3.6-14.9 8.5-22.6 15.2-19.7 17.1-41.4 48-41.4 105.7zm64 176l-112 0 0-176C288 57.1 364.4 14.5 400 3.3 407.5 1 413.2 0 416 0l32 0 0 512-48 0 0-160z",
  iconType: "fill",
  fill: "none"
};

// src/vacuum.tsx
var vacuum = {
  iconName: "vacuum",
  width: 640,
  height: 512,
  svgPathData: "M528 48l-284.6 0-71.5 336 52.1 0 0 128-224 0 0-64 64-64 58.9 0 77.7-365 4-19 323.4 0c61.9 0 112 50.1 112 112 0 44.8-26.3 83.5-64.3 101.4 20.4 30.5 32.3 67.2 32.3 106.6l0 192-139.3 0c14.8-13 26.5-29.4 34-48l57.3 0 0-144c0-79.5-64.5-144-144-144l-16 0 0 113c-5.2-.7-10.6-1-16-1-11 0-21.8 1.4-32 4l0-164 64 0c47.9 0 91.8 17.6 125.4 46.6 28.9-6.1 50.6-31.9 50.6-62.6 0-35.3-28.7-64-64-64zM432 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM83.9 432l-32 32 124.1 0 0-32-92.1 0zM384 400a16 16 0 1 1 0 32 16 16 0 1 1 0-32z",
  iconType: "fill",
  fill: "none"
};

// src/warning.tsx
var warning = {
  iconName: "warning",
  width: 576,
  height: 512,
  svgPathData: "M16 480L42.3 432 260.6 33.9 288-16 315.4 33.9 533.7 432 560 480 16 480zM288 83.8L97.1 432 478.9 432 288 83.8zM264 200l0-8 48 0 0 128-48 0 0-120zm48 208l-48 0 0-48 48 0 0 48z",
  iconType: "fill",
  strokeWidth: 0
};

// src/houseChimney.tsx
var houseChimney = {
  iconName: "house-chimney",
  width: 576,
  height: 512,
  svgPathData: "M304.4 6.1l-16-14.4-16 14.4-232 208-17.9 16 32 35.7c13.6-12.2 22.2-19.9 25.8-23.2l0 269.3 416 0 0-269.3c3.7 3.3 12.3 11 25.8 23.2l32-35.7c-8.2-7.4-27.5-24.7-57.9-51.9l0-114.2-48 0 0 71.2-144-129.1zm144 193.6l0 264.3-64 0 0-176.5-192 0 0 176.5-64 0 0-264.3 160-143.5 160 143.4zM240.4 464l0-128.5 96 0 0 128.5-96 0z",
  iconType: "fill",
  fill: "none"
};

// src/buildingCircleArrowRight.tsx
var buildingCircleArrowRight = {
  iconName: "building-circle-arrow-right",
  width: 576,
  height: 512,
  svgPathData: "M80 48l288 0 0 170.9c15.2-5.4 31.3-8.9 48-10.3L416 0 32 0 32 512 276 512c-22.7-31.5-36-70.2-36-112 0-16.6 2.1-32.7 6-48l-70 0 0 112-96 0 0-416zM320 224l-64 0 0 64 20 0c12.2-16.9 27-31.8 44-44l0-20zM128 96l0 64 64 0 0-64-64 0zm192 0l-64 0 0 64 64 0 0-64zM128 224l0 64 64 0 0-64-64 0zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM440 321.4l11.3 11.3 56 56 11.3 11.3-11.3 11.3-56 56-11.3 11.3-22.6-22.6c4.6-4.6 18-18 40-40l-105.4 0 0-32 105.4 0c-22-22-35.4-35.4-40-40L440 321.4z",
  iconType: "fill",
  fill: "none"
};

// src/city.tsx
var city = {
  iconName: "city",
  width: 576,
  height: 512,
  svgPathData: "M208 0l256 0 0 192 112 0 0 320-576 0 0-416 48 0 0-96 48 0 0 96 32 0 0-96 48 0 0 96 32 0 0-96zM176 144l-128 0 0 320 160 0 0-320-32 0zM528 464l0-224-112 0 0-192-160 0 0 416 272 0zM304 96l64 0 0 64-64 0 0-64zM480 288l0 64-64 0 0-64 64 0zM304 192l64 0 0 64-64 0 0-64zM160 256l-64 0 0-64 64 0 0 64zm144 32l64 0 0 64-64 0 0-64zM160 352l-64 0 0-64 64 0 0 64z",
  iconType: "fill",
  fill: "none"
};

// src/carBuilding.tsx
var carBuilding = {
  iconName: "car-building",
  width: 576,
  height: 512,
  svgPathData: "M48 48l288 0 0 63.8 48 0 0-111.8-384 0 0 480 144 0 0-48-96 0 0-384zm96 240l16 0 0-64-64 0 0 64 48 0zM96 96l0 64 64 0 0-64-64 0zm184 63.9l-17.6 0-5.3 16.8-34.7 111.2-30.4 0 0 224 48 0 0-32 288 0 0 32 48 0 0-224-30.4 0-34.7-111.2-5.3-16.8-225.6 0zm248 240l0 32-288 0 0-96 288 0 0 64zm-32.6-112l-222.7 0 25-80 172.7 0 25 80zM312 383.9a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z",
  iconType: "fill",
  fill: "none"
};

// src/buildingCircleCheck.tsx
var buildingCircleCheck = {
  iconName: "building-circle-check",
  width: 576,
  height: 512,
  svgPathData: "M80 48l288 0 0 170.9c15.2-5.4 31.3-8.9 48-10.3L416 0 32 0 32 512 276 512c-22.7-31.5-36-70.2-36-112 0-16.6 2.1-32.7 6-48l-70 0 0 112-96 0 0-416zM320 224l-64 0 0 64 20 0c12.2-16.9 27-31.8 44-44l0-20zM128 96l0 64 64 0 0-64-64 0zm192 0l-64 0 0 64 64 0 0-64zM128 224l0 64 64 0 0-64-64 0zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-73.6-51.5l-9.4 12.9-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L353.4 400 376 377.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8z",
  iconType: "fill",
  fill: "none"
};
export {
  arrowDownToBracket,
  arrowDownToLine,
  bell,
  bin,
  boxOpen,
  briefcase,
  broomWide,
  buildingCircleArrowRight,
  buildingCircleCheck,
  calendar,
  calendarClock,
  calendarDay,
  carBuilding,
  chartMixedUpCircleDollar,
  chartUser,
  chevronDown,
  chevronLeft,
  chevronRight,
  chevronUp,
  chevronUpDown,
  circleDollar,
  circleInfo,
  circleQuestion,
  circleSterling,
  circleTick,
  city,
  clock,
  creditCard,
  creditCardSync,
  cross,
  dollarSign,
  dropdown,
  error,
  errorCircle,
  fett,
  fileArrowDown,
  fileCertificate,
  fileCircleInfo,
  fileCirclePlus,
  filePen,
  fileShield,
  fileSignature,
  grid2,
  handHoldingHeart,
  handshake,
  home,
  houseChimney,
  houseHeart,
  leftArrow,
  lightbulbOn,
  link,
  list,
  loading,
  lock,
  lockKeyhole,
  magnifierPlus,
  menu,
  message,
  messageQuestion,
  messageSmile,
  minus,
  moneyBill,
  newspaper,
  notdef,
  paintRoller,
  paintbrushPencil,
  pen,
  penToSquare,
  pencil,
  plug,
  plus,
  question,
  refreshArrow,
  refreshCircle,
  rightArrow,
  rocketLaunch,
  rulerTriangle,
  sb,
  screwdriverWrench,
  search,
  shieldCheck,
  shieldHeart,
  simplybusiness,
  sparkles,
  sprinkler,
  square,
  squareTick,
  star,
  sterlingSign,
  store,
  tag,
  telephone,
  thumbsUp,
  tick,
  tree,
  truck,
  user,
  userHelmetSafety,
  userShield,
  users,
  utensils,
  vacuum,
  warning
};
